export default __webpack_public_path__ + "static/media/BCA10.c1b0c7da.jpg";